import { computed, ref, useContext } from '@nuxtjs/composition-api';
import { getCMSLabels } from '~/helpers/globalLabels';
import { useUserStore } from '~/stores/user-store';
import { userCheckoutStore } from '~/stores/checkout-store';
import { useSapcc, useUiNotification, useUiState } from "~/composables";
import { adaptProduct } from "~/helpers/analytics/helper";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { AnalyticsCartActions } from "~/helpers/analytics/types";
import { CMSNotificationType } from "~/helpers/extractCMSNotificationMessage";

export default function useProductMixin(props) {
  const { i18n, $cookies } = useContext();
  const appKey = i18n.localeProperties.appKey;
  const userStore = useUserStore();
  const { toggleLoginModal } = useUiState();
  const { send: sendNotification } = useUiNotification();
  const { addToShoppingCart: addCartItem, error: AddToCartError } = useSapcc('existingCart');
  const {  loadShoppingCart: loadCart, loading: initiatingCart } = useSapcc('loadExistingCart');
  const showLoader = ref(false);
  const isOutOfStock = ref(props.isOutOfStock);
  const onlyAvailableTo = ref(props.onlyAvailableTo);
  const addedToCartMessage = getCMSLabels('added-cart');
  const useCheckoutStore = userCheckoutStore();

  const showModelPopup = (availableTo) => {
    return !userStore.getUserIsLoggedIn && availableTo;
  }

  const handleProductAddToCart = (availableTo) => {
    if (showModelPopup(availableTo)) {
      toggleLoginModal();
      return false;
    }
    return true;
  }
  const checkProductAvailability = (stock, onlyAvailable) => {
    if (!props.isListingPage) {
      isOutOfStock.value = !stock
      onlyAvailableTo.value = onlyAvailable
    }
  }

  const addItem = async (productObj, productName, availableTo) => {
    const cartGuid = computed(() => $cookies.get(`${appKey}#ci`));
    const addToCartResponse = handleProductAddToCart(availableTo);
    if (!addToCartResponse) {
      return;
    }
    if (props.isListingPage) {
      const productForEvent = adaptProduct(props.product, 'SfProductCart')
      analyticsEvents.updateCartItem(AnalyticsCartActions.ADD, productForEvent)
    }

    try {
      showLoader.value = true;
      if (!cartGuid.value) {
        useCheckoutStore.removeAllProductsInCart(appKey);
        await loadCart();
      }


      await addCartItem(productObj);
      if (AddToCartError.value?.status === 403) {
        sendNotification({
          type: CMSNotificationType.ERROR,
          message: AddToCartError.value?.message
        });
      } else {
        sendNotification({
          type: CMSNotificationType.SUCCESS,
          message: `${productName} ${addedToCartMessage}.`
        });
      }
    } catch (error) {
      sendNotification({
        type: CMSNotificationType.ERROR,
        message: error
      });
    } finally {
      showLoader.value = false;
    }
  };

  const getExclusiveProductText = computed(() => {

    return onlyAvailableTo.value? getCMSLabels('my-moomin-exclusive'):''
  })

  const getAddToCartButtonText = computed(() => {
      const addToCartLabel = getCMSLabels('addtocart');
      const outofstockLabel = getCMSLabels('get-notified');
      const loginToBuyLabel = getCMSLabels('log-in-to-buy');

      if (userStore.getUserIsLoggedIn && Object.keys(userStore).length) { // User authenticated

        if (onlyAvailableTo.value === userStore.getUserGroup && !isOutOfStock.value) { // onlyAvailableTo match with current user group and product is in stock
          return addToCartLabel;
        } else if (onlyAvailableTo.value === userStore.getUserGroup && isOutOfStock.value){ // onlyAvailableTo match with current user group and product is out of stock
          return outofstockLabel;
        } else {
         return addToCartLabel; //Global add to cart label
        }

      } else if (onlyAvailableTo.value == '' && !isOutOfStock.value){ // Not onlyavailableto field there and product has not out of stock
        return addToCartLabel;
      } else if (onlyAvailableTo.value != '' && !isOutOfStock.value) {
        return loginToBuyLabel;
      } else {
        return outofstockLabel;
      }

    })

  return {
    getAddToCartButtonText,
    addItem,
    showLoader,
    getExclusiveProductText,
    initiatingCart,
    handleProductAddToCart,
    checkProductAvailability
  };
}
